import { render, staticRenderFns } from "./PengurusPusatEdit.vue?vue&type=template&id=0008586c&scoped=true"
import script from "./PengurusPusatEdit.vue?vue&type=script&lang=js"
export * from "./PengurusPusatEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008586c",
  null
  
)

export default component.exports